import React from 'react';
import { ArticleIndex } from 'containers/slices/containers/ArticleIndex';
import { IArticleIndex } from './schema';

export const ArticleIndexSlice = ({
  title,
  tagline,
  items,
  tags,
  matchAll,
  featured,
  filter,
  lang,
}) => {
  return (
    <ArticleIndex
      title={title}
      tagline={tagline}
      items={items}
      tags={tags}
      matchAll={matchAll}
      featured={featured}
      filter={filter}
      lang={lang}
    />
  );
};

export default ArticleIndexSlice;
